export const formatRows = (listaItems, tipoprecio) =>
  listaItems.map((item, index) => {
    // Obtener descripción del artículo desde la relación o directamente
   
    const artDescripcion = item.lista_Art?.art_descripcion 
      || item.lista_articulos?.art_descripcion 
      || item.art_descripcion 
      || "Sin descripción";
    
    const artCodigo = item.lista_Art?.art_codigo 
      || item.lista_articulos?.art_codigo 
      || item.art_codigo 
      || "";
    const artCosto = item.lista_Art?.art_npreciocosto 
      || item.lista_articulos?.art_npreciocosto 
      || item.art_npreciocosto 
      || "";
    return {
      // ID único para DataGrid (clave compuesta simulada)
      id: item.art_id  ,
      art_id: item.art_id,
      lp_id: item.lp_id,
      art_codigo: artCodigo,
      art_descripcion: artDescripcion,
      art_npreciocosto: Number(artCosto || 0).toFixed(2),
      alp_art_npreciocosto: Number(item.alp_art_npreciocosto || 0).toFixed(2),
      alp_art_nprecioventa: Number(item.alp_art_nprecioventa || 0).toFixed(2),
      alp_art_npreciomayorista: Number(item.alp_art_npreciomayorista || 0).toFixed(2),
      alp_porclista: Number(item.alp_porclista || 0).toFixed(2),
      alp_margen: Number(item.alp_margen || 0).toFixed(2),
      alp_imp_fijo: Number(item.alp_imp_fijo || 0).toFixed(2),
      alp_tipo_actualizacion: item.alp_tipo_actualizacion || 0,
      alp_show_web: item.alp_show_web === 0 ? "✅" : "❌",
      alp_show_app: item.alp_show_app === 0 ? "✅" : "❌",
    };
  });
